import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './modalComponent.css'

interface ModalComponentProps {
    title?: string;
    children?: React.ReactNode;
    modalClassName?: string;
    contentClassName?: string;
    bodyClassName?: string;
    backdrop?: any;
    size?: string;
    onClose?: () => void;
}

const ModalComponent: React.FC<ModalComponentProps> = ({
    title,
    children,
    modalClassName,
    contentClassName,
    bodyClassName,
    backdrop = 'static',
    size,
    onClose
}) => {
    const [modal, setModal] = useState<boolean>(true);

    const toggle = useCallback(() => {
        setModal((previous: boolean) => !previous);
        if (onClose) {
            onClose();
        }
    }, [onClose])

    const listenKeyboard = useCallback((event: KeyboardEvent) => {
        if (event.key === 'Escape' || event.keyCode === 27) {
            if (onClose) {
                onClose();
            }
        }
    },
        [onClose]
    );

    useEffect(() => {
        if (onClose) {
            window.addEventListener('keydown', listenKeyboard, true);
        }
        return (() => {
            if (onClose) {
                window.removeEventListener('keydown', listenKeyboard, true);
            }
        })
    }, [onClose, listenKeyboard]);

    return (
        <div>
            <Modal isOpen={modal}
                toggle={toggle}
                modalClassName={modalClassName}
                contentClassName={contentClassName}
                backdrop={backdrop}
                size={size}
            >
                {title && <ModalHeader toggle={toggle}>{title}</ModalHeader>}
                <ModalBody className={bodyClassName}>
                    {children}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}
export default ModalComponent;